import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DataTable from "../components/UI/DataTable/DataTable";
import { HISTORY_TABLE_COLUMNS } from "../constants/Constants";
import { commonActions } from "../redux/reducers/CommonReducer";
import { TABLES } from "../enums/Enums";
import store from "../redux/Store";
import * as actionsService from "../services/ActionsService/ActionsService";
import * as validationsActions from "../services/ActionsService/ValidationsActionsService";
import { getSiteByScopeId } from "../utils/UsersUtils";
import { convertCurrencyToSymbol } from "../utils/CommonUtils";
import { showErrorMessage } from "../utils/MessagesUtils";
import Strings from "../resources/Strings";
import { getTotalValidationAmount, getValidationHistoriesData } from "../utils/ValidationsUtils";

const useHistoryService = () => {
  const gmtUser = useSelector((state) => state.user.gmtUser);
  const historyColumns = HISTORY_TABLE_COLUMNS;
  const selectedScope = useSelector((state) =>  state.user?.selectedScope); 
  const sites = useSelector((state) => state.user.sites);
  const selectedSite = getSiteByScopeId(sites, selectedScope?.id);
  const siteCurrencySymbol = convertCurrencyToSymbol(selectedSite?.billingCurrency);
  const [inProcess, setInProcess] = useState(false);

  const [validationHistoriesData, setValidationHistoriesData] = useState({
    validationHistories: [],
    validationAmountSum: 0,
    validationHistoriesCount: 0,
    minDate: null,
    maxDate: null
  });

  const handleChange = (newProp) => {
    setValidationHistoriesData({ ...validationHistoriesData, ...newProp });
  };

  //Set all tables data
  useEffect(() => {
    const currentScope = selectedScope?.id;

    //Get Gmt Users
    if (!inProcess && currentScope) {
      setInProcess(true);

      validationsActions.getValidationHistoriesByChargeAccountId(gmtUser?.utronUser?.chargeAccount?.id, true, false).then((response) => {
        if (response.data.isSuccess) {
          let userIds = response.data.entity.map(vh => vh.userId);

          // Distinct array
          userIds = userIds.filter((id, index) => userIds.findIndex((userId) => userId === id) === index); 
          let scopesIds = [currentScope];

          actionsService.getUsersIdentityData(userIds, scopesIds, true, true).then((userIdsResponse) => {
            if (userIdsResponse.data.isSuccess) {
              const {validationHistories, validationAmountSum, validationHistoriesCount, minDate, maxDate} = getValidationHistoriesData(userIdsResponse?.data?.entity, response?.data?.entity, selectedSite, siteCurrencySymbol);
              
              handleChange({
                "validationHistories": validationHistories,
                "validationAmountSum": validationAmountSum,
                "validationHistoriesCount": validationHistoriesCount,
                "minDate": minDate,
                "maxDate": maxDate
              });
            }
            else {
              //error
              showErrorMessage(userIdsResponse.data?.error);
              store.dispatch(commonActions.setIsShowLoadingSpinner(false));
            }
          }).catch(error => {
            showErrorMessage(error);
            store.dispatch(commonActions.setIsShowLoadingSpinner(false));
          });      
        }
        else {
          //error
          showErrorMessage(response.data?.error);
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        }

        setInProcess(false);
        store.dispatch(commonActions.setIsFirstTimeLoading(false));
        
      }).catch(error => {
         console.log(error);
         showErrorMessage(error);
         store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      });
    }
  }, [selectedScope]); 

  const getHistoryTable = (eventFn) => {
    return ( selectedScope &&
      <DataTable
        onRowClick={eventFn}
        columns={historyColumns}
        rows={validationHistoriesData?.validationHistories} 
        toolBarTitle={{
           "title": Strings.TOOLBAR_TITLE.VALIDATION_HISTORY, 
           "value": `${siteCurrencySymbol}${validationHistoriesData?.validationAmountSum}`
        }}
        toolBarSecondaryTitle={{
          "title": Strings.TOOLBAR_TITLE.VALIDATION_HISTORY_SECONDARY, 
          "value": `${validationHistoriesData?.validationHistoriesCount}`
        }}
        tableId={TABLES.HISTORY}
        selectedScope={selectedScope}
        minDate={validationHistoriesData?.minDate}
        maxDate={validationHistoriesData?.maxDate}
        onFilteredRowsChange={(event) => {
          handleChange({
            "validationAmountSum": getTotalValidationAmount(event),
            "validationHistoriesCount": event?.length
          });
        }}
        onSearchedRowsChange={(event) => {
          handleChange({
            "validationAmountSum": getTotalValidationAmount(event),
            "validationHistoriesCount": event?.length
          });
        }}
      ></DataTable>
    );
  };

  return {
    getHistoryTable
  };
};

export default useHistoryService;
